// Stripe subscription status types based on Stripe API documentation
export type StripeSubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'past_due'
  | 'paused'
  | 'trialing'
  | 'unpaid';

export const SUBSCRIPTION_ACTIVE_STATUSES = ['active', 'trialing'] as StripeSubscriptionStatus[];

export interface CampaignLimits {
  currentActiveCount: number;
  maxActiveAllowed: number;
  canCreateMore: boolean;
}

export interface User {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  auth0Id: string;
  lastLogin?: Date;
  discordId?: string;
  discordUsername?: string;
  discordAvatar?: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
  sessions?: unknown[];
  players?: User[];
  dungeonMasters?: User[];
  mainUser?: User;
  stripeSubscriptionStatus?: StripeSubscriptionStatus;
  isAdmin?: boolean;
}

export interface UserSettings {
  sendRequesterLeaveWarning?: boolean;
  [key: string]: unknown;
}
